module.exports = __webpack_public_path__ + "static/media/Line-Up_Review_Paciente_1.003b74c2.jpg";